module.exports = __webpack_public_path__ + "static/media/Logo_Intesa.41ba19f4.png";